import React, { createContext, useState, useContext, useEffect } from 'react';
import { useUser } from './userContext';

const PermissionContext = createContext(null);

export function PermissionProvider({ children }) {
    const { user } = useUser();
    const [features, setFeatures] = useState([]);   // Liste von feature_keys
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        async function fetchFeatures() {
            if (!user || !user.api_key) {
                setFeatures([]);
                setIsLoading(false);
                return;
            }
            try {
                setIsLoading(true);
                setError(null);

                const resp = await fetch(`${process.env.REACT_APP_API_URI}/api/permissions/my-features`, {
                    headers: { 'Authorization': user.api_key }
                });
                if (!resp.ok) {
                    throw new Error(`HTTP ${resp.status}`);
                }
                const data = await resp.json();
                setFeatures(data || []);
            } catch (err) {
                setError(err.message);
                setFeatures([]);
                console.error('Fehler beim Laden der Features:', err);
            } finally {
                setIsLoading(false);
            }
        }

        fetchFeatures();
    }, [user]);

    // Prüft, ob der User über sein Feature-Array verfügt
    const hasFeature = (featureKey) => {
        return features.includes(featureKey);
    };

    return (
        <PermissionContext.Provider value={{ features, hasFeature, isLoading, error }}>
            {children}
        </PermissionContext.Provider>
    );
}

export function usePermissions() {
    return useContext(PermissionContext);
}